import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { loginSuccess, logout } from "../redux/actions/LoggedInAction";
import UserResources from "../resources/UserResources";
import { toast } from "react-toastify";
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Topbar from "../layouts/TopBar";
import Footer from "../layouts/Footer";
import moment from "moment";
import {ACCESS_DENIED} from '../Messages'

function TeamMemberProfile({isLoggedIn, loggedInUser, logout}){
    const location = useLocation();
    const [user, setUser] = useState([])
    const [userId, setUserId] = useState('')
    const userResources = new UserResources()

    const loadUsers = (id, loggedInID) => {        
        return userResources.get_admin_single_user(id, loggedInID)
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        //const searchParamss = queryString.parse(location.search)
        
        const userIdRaw = searchParams.get('mot');
        const userId = userIdRaw.split("ia293b")[1]
        setUserId(userId)
        if (loggedInUser !== null){
            loadUsers(userId, loggedInUser['id']).then(response => {
                setUser(response['body']);
            }).catch((err) => {
                toast.error("Network error: " + err)
            });
        }        
    }, []);


    return(
        <Fragment>
             <Topbar/>  
                <div className="hero-area">
                <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                            {isLoggedIn ?
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>{user['firstname']} {user['lastname'] + '\'s'} Profile </strong></h1>
                                :
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>{ACCESS_DENIED}</strong></h1>
                            }
                        </div>
                    </div>
                </div>
            </div>
                  

                <div id="main-container">
                <div className="content">
                    {
                        isLoggedIn ?

                    <div className="container">
                        <div className="spacer-40"></div>

                        {/* Profile Header Card */}
                        <div style={{backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', padding: '28px 24px', marginBottom: '20px', textAlign: 'center'}}>
                            <div style={{width: '140px', height: '140px', borderRadius: '50%', overflow: 'hidden', margin: '0 auto 16px', border: '3px solid #ffa800'}}>
                                <img src={user['image']} style={{width: '100%', height: '100%', objectFit: 'cover'}} alt=""/>
                            </div>
                            <h2 style={{color: '#003165', margin: '0 0 4px', fontSize: 'clamp(20px, 5vw, 26px)'}}>{user['firstname']} {user['lastname']}</h2>
                            <p style={{color: '#ffa800', fontWeight: 'bold', margin: '0 0 4px', fontSize: 'clamp(13px, 3.5vw, 15px)'}}>{user['role.name']}</p>
                            <p style={{color: '#999', margin: 0, fontSize: 'clamp(12px, 3vw, 13px)'}}>Joined {moment(user['date_of_joining']).format('MMMM YYYY')}</p>
                        </div>

                        {/* Bio Card - only shown if bio exists */}
                        {user['about'] && (
                            <div style={{backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', padding: '20px 24px', marginBottom: '20px'}}>
                                <h4 style={{color: '#003165', margin: '0 0 10px', fontSize: 'clamp(14px, 3.8vw, 16px)'}}>About</h4>
                                <p style={{color: '#555', margin: 0, fontSize: 'clamp(13px, 3.5vw, 14px)', lineHeight: '1.6'}}>{user['about']}</p>
                            </div>
                        )}

                        {/* Details Card */}
                        <div style={{backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', padding: '20px 24px', marginBottom: '20px'}}>
                            <h4 style={{color: '#003165', margin: '0 0 16px', fontSize: 'clamp(14px, 3.8vw, 16px)'}}>Details</h4>
                            {[
                                { label: 'Media Skills', value: user['competencies'] },
                                { label: 'Primary Location', value: user['location.name'] },
                                { label: 'Birthday', value: moment(user['date_of_birth']).format('DD MMMM') }
                            ].map((detail, idx) => (
                                <div key={idx} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: idx < 2 ? '1px solid #f0f0f0' : 'none'}}>
                                    <span style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>{detail.label}</span>
                                    <span style={{color: '#555', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>{detail.value}</span>
                                </div>
                            ))}
                        </div>

                        {/* Church Progression Card */}
                        <div style={{backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', padding: '20px 24px', marginBottom: '20px'}}>
                            <h4 style={{color: '#003165', margin: '0 0 16px', fontSize: 'clamp(14px, 3.8vw, 16px)'}}>Church Progression</h4>
                            <div style={{display: 'flex', gap: '12px', flexWrap: 'wrap'}}>
                                {[
                                    { label: 'Connect', done: user['done_connect'] === 'True' },
                                    { label: 'Fortify', done: user['done_fortify'] === 'True' },
                                    { label: 'Serve', done: user['done_serve'] === 'True' }
                                ].map((stage) => (
                                    <div key={stage.label} style={{
                                        flex: '1 1 80px',
                                        textAlign: 'center',
                                        padding: '10px 16px',
                                        borderRadius: '8px',
                                        backgroundColor: stage.done ? '#e8f8f0' : '#fff3cd',
                                        border: '1px solid ' + (stage.done ? '#c3e6d3' : '#ffe08a')
                                    }}>
                                        <p style={{margin: '0 0 4px', color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>{stage.label}</p>
                                        <p style={{margin: 0, fontWeight: 'bold', fontSize: 'clamp(12px, 3.2vw, 13px)', color: stage.done ? '#35ab7c' : '#856404'}}>{stage.done ? 'Done' : 'Pending'}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

        

                        <div className="spacer-40"></div>
                    </div>:
                    <></>
                    }
                </div>
            </div>

                <Footer/>
        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
    
};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(TeamMemberProfile);